// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Bcx6","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3BGuW"};